import React, { useState } from "react";
import "./EducationLoan.css";
import { tableData } from "../data/educationLoanData";
import loanTermsData from "../data/educationLoanData";
import Button from "../components/Button/Button";
import BankingSlide from "../components/bankingSlide/BankingSlide";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import Edulogo1 from '../assets/icons/Edulogo1.svg';
import Edulogo2 from '../assets/icons/Edulogo2.svg';
import Toast from '../components/Toast/Toast';
import { useDispatch, useSelector } from "react-redux";
import { useLoanApplyMutation } from "../store/api/userApiSlice";
import { openAuthModal } from "../store/slices/authSlice";

const EducationLoan = () => {
        const user = useSelector((state) => state.auth.userInfo);
        const dispatch = useDispatch();
        const [loanApply] = useLoanApplyMutation();
        const token = useSelector((state) => state.auth.token);
        const [toastVisible, setToastVisible] = useState(false);
        const [toastMessage, setToastMessage] = useState('');


   const handleApplyNow = async () => {
    if (!user || !token) {
      // User not logged in, prompt login
      dispatch(openAuthModal());
      return;
    }

    try {
      const applicationData = {
      name: user.firstName + ' ' + user.lastName,
      email: user.email,
      contactNumber: user.contactNumber,
      };

      const response = await loanApply(applicationData).unwrap();
      console.log("Loan application successful:", response);
      setToastMessage('Loan application submitted successfully!');
      setToastVisible(true);
      // Optionally show a success message to the user
    } catch (error) {
      console.error("Failed to apply for loan:", error);
      // Optionally show an error message to the user
    } 
   }


   const renderCell = (data, type, color) => {
    
    if (type === "list") {
      return (
        <ul className={`loan-list ${color.replace('loan-list ', '')}`}>
          {Array.isArray(data) ? data.map((item, i) => (
            <li key={i}>{item}</li>
          )) : <li>{data}</li>}
        </ul>
      );
    }

    if (type === "badge") {
      return <span className="loan-blue-chips">{data}</span>;
    }

    return data;
  };

  return (
    <div className="loan-page">
      <Navbar />
      {/* HERO */}
      <div className="loan-hero">
        <div className="loan-hero-content">
          <h1>Education loans</h1>
           <h1>made simple</h1>
          <p className="loan-description">Don’t let finances limit your future. Empower your ambitions with accessible education loans designed to help</p>
          <p>you study where you want and become who you aspire to be.</p>
        </div>
      </div>

      {/* Loan card */}
      <section className="loan-card-section">
        {/*card-1*/}
        <div className="loan-card-1">
          <div className="loan-card-1-header">
            <h4>
                <img src={Edulogo1} alt="Education Loan" className="loan-logo"/>
                Post-Graduation Courses Unsecured Loan
            </h4>
          </div>
          <div className="loan-card-1-info">
            <table className="loan-doc-table">
              <thead>
                <tr>
                 <th>Category</th>
                 <th>Student / Applicant</th>
                 <th>Self-Employed Guarantor</th>
                 <th>Salaried Guarantor</th>
                </tr>
              </thead>

              <tbody>
               {tableData.map((row, index) => (
                 <tr key={index}>
                   <td className="loan-category">{row.category}</td>

                   <td>
                    {renderCell(row.student, row.type, "loan-list blue")}
                   </td>

                   <td>
                    {renderCell(row.selfEmployed, row.type, "loan-list orange")}
                   </td>

                   <td>
                   {renderCell(row.salaried, row.type, "loan-list green")}
                   </td>
                  </tr>
                ))}
              </tbody>
           </table>
          </div>
          <div className="loan-card-btn">
            <Button className="apply-btn" onClick={handleApplyNow} showArrow={false}>APPLY NOW</Button>
          </div>
        </div>
        {/*Card-2*/}
        <div className="loan-card-2">
          <div className="loan-card-2-header">
            <h4>
                <img src={Edulogo2} alt="Education Loan" className="loan-logo"/>
                For Graduation Courses (Secured Loan)
            </h4>
          </div>
          <div className="loan-card-2-info">
            <div className="loan-terms-container">
              <h3 className="loan-heading">
               <span className="loan-icon">%</span> Loan Terms & Rates
              </h3>

              <div className="loan-cards">
               {loanTermsData.map((item, index) => (
                 <div className="loan-term-card" key={index}>
                    <div className="loan-card-title">
                     <span className="loan-dot" />
                     {item.title}
                    </div>

                    <p className="loan-label">Interest Rate Range:</p>

                    <div className="loan-rate-box">{item.range}</div>
                  </div>
                ))}
              </div>

              <div className="loan-processing-fee">
               <span>Processing Fee:</span> 1% to 1.5%(for all Secured/NBFC partners)
              </div>
            </div>
          </div>
          <div className="loan-card-btn">
            <Button className="apply-btn" onClick={handleApplyNow} showArrow={false}>APPLY NOW</Button>
          </div>
        </div>

      </section>  
      {/* BANK PARTNERS */}
      <BankingSlide />
      <Footer/>
          <Toast 
        message={toastMessage} 
        isVisible={toastVisible} 
        onClose={() => setToastVisible(false)} 
      />
    </div>
  );
};

export default EducationLoan;
